/**
 * Gets the correct top-level cookie domain from the environment.
 * This allows cookies (like language preferences) to be shared across subdomains.
 */
export const getCookieDomain = (): string | undefined => {
  // We use the REACT_APP_SSO_URI environment variable as the reference point,
  // as it is guaranteed to be on the main domain.
  const ssoUrl = process.env.REACT_APP_SSO_URI || 'https://sso.noviopus.com/api'; 
  
  if (!ssoUrl) {
    return undefined;
  }

  try {
    // Standardize URL (handle missing protocol if necessary, though env var usually has it)
    const urlString = ssoUrl.startsWith('http') ? ssoUrl : `https://${ssoUrl}`;
    const url = new URL(urlString);
    const hostname = url.hostname; // e.g., "sso.dev.noviopus.com"

    if (hostname === 'localhost') {
      return undefined; // Let browser handle localhost
    }

    const hostnameParts = hostname.split('.'); 
    
    // Logic:
    // sso.dev.noviopus.com (4 parts) -> .dev.noviopus.com
    // sso.noviopus.com (3 parts) -> .noviopus.com
    if (hostnameParts.length >= 3) {
      return '.' + hostnameParts.slice(1).join('.');
    }
    
    return '.' + hostname;
  } catch (e) {
    console.error('Could not parse REACT_APP_SSO_URI to determine cookie domain.', e);
    return undefined;
  }
};